import { render, staticRenderFns } from "./OrderYxhd.vue?vue&type=template&id=52853fcd&scoped=true&"
import script from "./OrderYxhd.vue?vue&type=script&lang=js&"
export * from "./OrderYxhd.vue?vue&type=script&lang=js&"
import style0 from "./OrderYxhd.vue?vue&type=style&index=0&id=52853fcd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52853fcd",
  null
  
)

export default component.exports